import gettext from '@sdk/lang/gettext';

import Icon from '@web/assets/svg/Icons/32/newsfeed-blue.svg';
import { UserPreviewListModal } from '@web/newsfeed/components/UserPreviewListModal/UserPreviewListModal';
import { LikedByProps } from '@web/newsfeed/types/LikedByProps';

import { useLikedBy } from './likedBy.hooks';

type Props = {
  isVisible: boolean;
  onClose: () => void;
} & LikedByProps;

export const LikedByModal = ({
  isVisible,
  onClose,
  pageId,
  articleId,
  commentId,
  likedByCount,
}: Props) => {
  const { isLoading, data } = useLikedBy({ pageId, articleId, commentId, likedByCount });

  return (
    <UserPreviewListModal
      isVisible={isVisible}
      onClose={onClose}
      isLoading={isLoading}
      icon={<Icon />}
      title={gettext('Liked by')}
      users={data}
    />
  );
};
